import React, { useCallback } from "react";
import noop from "lodash/noop";

import {
    Table as TableView,
    Paper,
    TableContainer,
    Box,
    Card,
} from "@mui/material";
import TableHeader from "../TableHeader";
import { PAGINATION } from "utils/constants/pagination";
import AuditLogsTableBody from "./AuditLogsTableBody";
import MasterPagination from "utils/MasterPagination";

const { INITIAL_PAGE, ROWS_PER_PAGE } = PAGINATION;

const AUDIT_LOGS_TABLE_HEADER = [
    { label: "Date & Time", type: "text", align: "left" },
    { label: "User", type: "text", align: "left" },
    { label: "User Role", type: "text", align: "left" },
    { label: "Company", type: "text", align: "left" },
    { label: "Module", type: "text", align: "left" },
    { label: "Action", type: "text", align: "left" },
    { label: "IP Address", type: "text", align: "left" },
    { label: "Status", type: "text", align: "left" },
    { label: "Description", type: "text", align: "left" },
    { label: "Details", type: "text", align: "center" }
];

interface AuditLogsTableProps {
    page?: number;
    onPageChange?: (page: number) => void;
    rowsPerPage?: number;
    onRowsPerPageChange?: (rows: number) => void;
    totalTableRowsCount?: number;
    totalPageCount?: number;
    allTableRows?: any;
}

const AuditLogsTable: React.FC<AuditLogsTableProps> = ({
    page = INITIAL_PAGE,
    onPageChange = noop,
    rowsPerPage = ROWS_PER_PAGE,
    onRowsPerPageChange = noop,
    totalTableRowsCount = INITIAL_PAGE,
    totalPageCount = INITIAL_PAGE,
    allTableRows = [],
}) => {
    const memoizedOnPageChange = useCallback(onPageChange, []);
    const memoizedOnRowsPerPageChange = useCallback(onRowsPerPageChange, []);
    return (
        <Card
            elevation={0}
            sx={{
                p: "0px 0px",
                mt: 1.5,
            }}
        >
            <Box overflow="hidden">
                <TableContainer
                    component={Paper}
                    sx={{ height: "inherit", overflowY: "auto" }}
                >
                    <TableView stickyHeader>
                        <TableHeader columns={AUDIT_LOGS_TABLE_HEADER} />
                        <AuditLogsTableBody allTableRows={allTableRows} />
                    </TableView>
                </TableContainer>
            </Box>
            <MasterPagination
                page={page}
                onPageChange={memoizedOnPageChange}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={memoizedOnRowsPerPageChange}
                totalTableRowsCount={totalTableRowsCount}
                totalPageCount={totalPageCount}
            />
        </Card>
    );
};

export default React.memo(AuditLogsTable);
